<script setup lang="ts" generic="T">
  import { type CellRenderProps } from "@krainovsd/vue-ui";
  import { computed } from "vue";
  import { formatIndicatorValue, parseIndicatorValue } from "@/entities/report";
  import type { IndicatorFormat } from "@/entities/report";

  type Props = {
    // Row field holding the numeric delta value.
    field: string;
    // Format for the absolute Δ value; ignored when `percent` is set.
    format?: IndicatorFormat;
    // Render as "{value}%" instead of a formatted indicator value.
    percent?: boolean;
  };

  const props = defineProps<CellRenderProps<T, Props>>();

  const value = computed(() =>
    parseIndicatorValue(
      (props.context.row.original as Record<string, unknown>)[props.settings?.field ?? ""],
    ),
  );

  const display = computed(() =>
    props.settings?.percent
      ? `${value.value}%`
      : formatIndicatorValue(value.value, props.settings?.format),
  );
</script>

<template>
  <span :class="[value > 0 && $style.positive, value < 0 && $style.negative]">{{ display }}</span>
</template>

<style lang="scss" module>
  .positive {
    color: var(--success);
  }

  .negative {
    color: var(--destructive);
  }
</style>
